// extracted by mini-css-extract-plugin
export default {"button":"ul-z","reviewSort":"vl-z"};